import e from "./_baseIsArguments.js";
import o from "./isObjectLike.js";
var t = Object.prototype, n = t.hasOwnProperty, s = t.propertyIsEnumerable, a = e(function() {
  return arguments;
}()) ? e : function(r) {
  return o(r) && n.call(r, "callee") && !s.call(r, "callee");
};
const m = a;
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/isArguments.js
// module id = 469
// module chunks = 67